module.exports = __webpack_public_path__ + "media/images/call_icon-a1ea00f28e4a95f94b5b16caf58f6b45.webp";